// // pages/SmartContentsPage.jsx
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import axios from "axios";
// import { toast } from "react-toastify";
// import Loader from "../components/common/Spinner";
// import { CONSTANTS } from "../constants/Constants";
// import { collection, getDocs, query, where } from "firebase/firestore";
// import { db } from "../firebaseConfig";

// const SmartContentsPage = () => {
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(true);
//   const [activeTab, setActiveTab] = useState("all");
//   const [activeSubTab, setActiveSubTab] = useState(null);
//   const [contentCategories, setContentCategories] = useState([]);
//   const [subCategories, setSubCategories] = useState([]);
//   const [smartContents, setSmartContents] = useState([]);
//   const [filteredContents, setFilteredContents] = useState([]);
//   const [benefits, setBenefits] = useState([]);
//   const [testimonials, setTestimonials] = useState([]);

//   // Fetch all required data
//   useEffect(() => {
//     window.scrollTo(0, 0);
//     fetchData();
//   }, []);

//   // Filter contents based on active tab and subtab
//   useEffect(() => {
//     if (activeTab === "all") {
//       setFilteredContents(smartContents);
//       setActiveSubTab(null);
//     } else {
//       const contentsForCategory = smartContents.filter(
//         (content) => content.category === activeTab
//       );

//       if (activeSubTab) {
//         const contentsForSubCategory = contentsForCategory.filter(
//           (content) => content.subCategory === activeSubTab
//         );
//         setFilteredContents(contentsForSubCategory);
//       } else {
//         setFilteredContents(contentsForCategory);
//       }
//     }
//   }, [activeTab, activeSubTab, smartContents]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);

//       // Try to fetch from Firestore first
//       let categoriesData = [];
//       let contentsData = [];

//       try {
//         // Fetch categories from Firestore
//         const categoriesSnapshot = await getDocs(
//           collection(db, "contentCategories")
//         );
//         categoriesData = categoriesSnapshot.docs.map((doc) => ({
//           _id: doc.id,
//           ...doc.data(),
//           identifier: doc.data().identifier || doc.id,
//         }));

//         // Fetch content from Firestore
//         const contentsSnapshot = await getDocs(collection(db, "smartContents"));
//         contentsData = contentsSnapshot.docs.map((doc) => ({
//           _id: doc.id,
//           ...doc.data(),
//           updatedAt: doc.data().updatedAt?.toDate?.() || new Date(),
//         }));
//       } catch (firestoreError) {
//         console.error("Firestore error:", firestoreError);

//         // Fallback to API if Firestore fails
//         try {
//           // Fetch categories from API
//           const categoriesRes = await axios.get(
//             `${CONSTANTS.APIURL}/api/content-categories?active=true`
//           );
//           categoriesData = categoriesRes.data.data;

//           // Fetch smart contents from API
//           const contentsRes = await axios.get(
//             `${CONSTANTS.APIURL}/api/smart-contents`
//           );
//           contentsData = contentsRes.data.data;
//         } catch (apiError) {
//           console.error("API error:", apiError);
//           toast.error("Failed to load content data");

//           // If both fail, use hardcoded data
//           categoriesData = getDefaultCategories();
//           contentsData = getDefaultContents();
//         }
//       }

//       // Add "All Content" category at the beginning
//       const allCategories = [
//         { _id: "all", name: "All Content", identifier: "all" },
//         ...categoriesData,
//       ];

//       setContentCategories(allCategories);
//       setSmartContents(contentsData);

//       // Set sub-categories based on the diagram
//       const defaultSubcategories = {
//         "10th_eng": [
//           { id: "academic_notes", name: "Academic Notes" },
//           { id: "sslc_board", name: "SSLC Board Old Q.P." },
//           { id: "model_qp", name: "Model Q.P." },
//           { id: "textbook", name: "Text Book" },
//         ],
//         "10th_kannada": [
//           { id: "academic_notes", name: "Academic Notes" },
//           { id: "sslc_board", name: "SSLC Board Old Q.P." },
//           { id: "model_qp", name: "Model Q.P." },
//           { id: "textbook", name: "Text Book" },
//         ],
//         navodaya: [
//           { id: "notes", name: "Notes" },
//           { id: "model_qp", name: "Q.P." },
//         ],
//         morarji: [
//           { id: "notes", name: "Notes" },
//           { id: "model_qp", name: "Q.P." },
//         ],
//         ncert: [
//           { id: "notes", name: "Notes" },
//           { id: "model_qp", name: "Q.P." },
//         ],
//       };

//       setSubCategories(defaultSubcategories);

//       // Fetch static data (benefits and testimonials)
//       fetchStaticData();

//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       toast.error("Failed to load content data");
//       setLoading(false);
//     }
//   };

//   // Default categories if API/Firestore fails
//   const getDefaultCategories = () => {
//     return [
//       { _id: "10th_eng", name: "10th English", identifier: "10th_eng" },
//       { _id: "10th_kannada", name: "10th Kannada", identifier: "10th_kannada" },
//       { _id: "navodaya", name: "Navodaya", identifier: "navodaya" },
//       { _id: "morarji", name: "Morarji", identifier: "morarji" },
//       { _id: "ncert", name: "NCERT", identifier: "ncert" },
//     ];
//   };

//   // Default contents if API/Firestore fails
//   const getDefaultContents = () => {
//     const defaultImages = [
//       "https://images.unsplash.com/photo-1503676260728-1c00da094a0b",
//       "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8",
//       "https://images.unsplash.com/photo-1522661067900-ab829854a57f",
//       "https://images.unsplash.com/photo-1434030216411-0b793f4b4173",
//     ];

//     // Generate sample contents for each category and subcategory
//     const contents = [];
//     const categories = getDefaultCategories();

//     categories.forEach((category) => {
//       const subcats = {
//         "10th_eng": ["academic_notes", "sslc_board", "model_qp", "textbook"],
//         "10th_kannada": [
//           "academic_notes",
//           "sslc_board",
//           "model_qp",
//           "textbook",
//         ],
//         navodaya: ["notes", "model_qp"],
//         morarji: ["notes", "model_qp"],
//         ncert: ["notes", "model_qp"],
//       }[category.identifier] || ["notes"];

//       subcats.forEach((subcat) => {
//         // Add 3 sample items for each subcategory
//         for (let i = 1; i <= 3; i++) {
//           contents.push({
//             _id: `${category.identifier}_${subcat}_${i}`,
//             title: `${category.name} - ${subcat.replace("_", " ")} ${i}`,
//             description: `Sample ${category.name} ${subcat.replace(
//               "_",
//               " "
//             )} content for educational purposes.`,
//             category: category.identifier,
//             subCategory: subcat,
//             imageUrl:
//               defaultImages[Math.floor(Math.random() * defaultImages.length)],
//             pages: Math.floor(Math.random() * 50) + 10,
//             format: Math.random() > 0.5 ? "PDF" : "DOC",
//             updatedAt: new Date(
//               Date.now() - Math.floor(Math.random() * 90) * 24 * 60 * 60 * 1000
//             ),
//             popular: Math.random() > 0.8,
//           });
//         }
//       });
//     });

//     return contents;
//   };

//   // Fetch static data (benefits and testimonials)
//   const fetchStaticData = () => {
//     const benefitsData = [
//       {
//         id: 1,
//         title: "Exam-Focused Content",
//         description:
//           "Content prepared by experts focusing only on exam-relevant information.",
//         icon: (
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
//             />
//           </svg>
//         ),
//       },
//       {
//         id: 2,
//         title: "Regular Updates",
//         description:
//           "Content regularly updated to include the latest examination patterns and syllabus changes.",
//         icon: (
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
//             />
//           </svg>
//         ),
//       },
//       {
//         id: 3,
//         title: "Simplified Complex Topics",
//         description:
//           "Difficult concepts simplified using easy language, diagrams, and examples.",
//         icon: (
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M13 10V3L4 14h7v7l9-11h-7z"
//             />
//           </svg>
//         ),
//       },
//       {
//         id: 4,
//         title: "Multiple Formats",
//         description:
//           "Content available in various formats including notes, model question papers, previous year questions, and textbook references.",
//         icon: (
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
//             />
//           </svg>
//         ),
//       },
//     ];

//     const testimonialsData = [
//       {
//         id: 1,
//         content:
//           "The smart content provided by SKYSEP was instrumental in my exam preparation. The concise notes and question papers helped me revise effectively.",
//         author: "Priya Verma",
//         rank: "96% in 10th Standard, 2023",
//         image:
//           "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDjtNi1m_f5OuxG9GcNMqa9i4F2sq_dVREdA&s",
//       },
//       {
//         id: 2,
//         content:
//           "What sets SKYSEP's study material apart is how they simplify complex topics. The question papers and notes especially helped me prepare thoroughly.",
//         author: "Rahul Sharma",
//         rank: "Selected for Navodaya, 2023",
//         image:
//           "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDjtNi1m_f5OuxG9GcNMqa9i4F2sq_dVREdA&s",
//       },
//       {
//         id: 3,
//         content:
//           "The model question papers and SSLC board old question papers were extremely helpful. They gave me a good idea of what to expect in the exams.",
//         author: "Amit Patel",
//         rank: "98% in Science, 2023",
//         image:
//           "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyBOAHtlqzaow5_rlz81tF3SwDxw4m5bYPzQ&s",
//       },
//     ];

//     setBenefits(benefitsData);
//     setTestimonials(testimonialsData);
//   };

//   // Function to format date
//   const formatDate = (dateString) => {
//     const options = { year: "numeric", month: "long", day: "numeric" };
//     return new Date(dateString).toLocaleDateString("en-US", options);
//   };

//   if (loading) {
//     return <Loader />;
//   }

//   return (
//     <div className="pt-20">
//       {/* Hero Section */}
//       <section className="relative bg-gradient-to-br from-[#2C5282] to-[#1A365D] text-white">
//         <div className="absolute inset-0">
//           <div className="absolute inset-0 bg-[#2C5282] opacity-70"></div>
//           <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&h=750&q=80')] opacity-10"></div>
//         </div>
//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
//           <div className="max-w-3xl">
//             <motion.h1
//               className="text-4xl md:text-5xl font-extrabold tracking-tight mb-6"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               Smart Study Content
//             </motion.h1>
//             <motion.p
//               className="text-lg md:text-xl mb-8 text-blue-100"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Access comprehensive study materials designed by experts to help
//               you excel in your exams. Choose from a wide range of academic
//               notes, question papers, and textbook resources.
//             </motion.p>
//             <motion.div
//               className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//             >
//               <Link
//                 to="/register"
//                 className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-[#2C5282] bg-white hover:bg-gray-100 transition-colors duration-300 shadow-md"
//               >
//                 Access Smart Content
//               </Link>
//               <Link
//                 to="/sample-content"
//                 className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
//               >
//                 View Sample Content
//               </Link>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Main Category Filter Tabs */}
//       <section className="bg-white py-8 border-b">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex flex-wrap justify-center">
//             {contentCategories.map((category) => (
//               <button
//                 key={category._id}
//                 onClick={() => {
//                   setActiveTab(category.identifier);
//                   setActiveSubTab(null);
//                 }}
//                 className={`px-5 py-2 m-1 rounded-full text-sm font-medium transition-colors ${
//                   activeTab === category.identifier
//                     ? "bg-[#2C5282] text-white"
//                     : "bg-blue-50 text-[#2C5282] hover:bg-blue-100"
//                 }`}
//               >
//                 {category.name}
//               </button>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Sub-Category Filter Tabs - Only show if a main category is selected */}
//       {activeTab !== "all" && subCategories[activeTab] && (
//         <section className="bg-gray-50 py-4">
//           <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//             <div className="flex flex-wrap justify-center">
//               {subCategories[activeTab].map((subCategory) => (
//                 <button
//                   key={subCategory.id}
//                   onClick={() => setActiveSubTab(subCategory.id)}
//                   className={`px-4 py-1 m-1 rounded-md text-sm transition-colors ${
//                     activeSubTab === subCategory.id
//                       ? "bg-blue-200 text-blue-800 font-medium"
//                       : "bg-white text-gray-600 hover:bg-blue-50"
//                   }`}
//                 >
//                   {subCategory.name}
//                 </button>
//               ))}
//             </div>
//           </div>
//         </section>
//       )}

//       {/* Content Grid */}
//       <section className="py-16 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {filteredContents.map((content, index) => (
//               <motion.div
//                 key={content._id}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow duration-300"
//               >
//                 <div className="relative h-48">
//                   <img
//                     src={content.imageUrl}
//                     alt={content.title}
//                     className="w-full h-full object-cover"
//                   />
//                   {content.popular && (
//                     <span className="absolute top-0 right-0 bg-[#2C5282] text-white px-3 py-1 text-xs font-medium">
//                       Popular
//                     </span>
//                   )}
//                 </div>
//                 <div className="p-6">
//                   <h3 className="text-xl font-bold text-[#2C5282] mb-2">
//                     {content.title}
//                   </h3>
//                   <p className="text-gray-600 mb-4 text-sm">
//                     {content.description}
//                   </p>

//                   <div className="flex justify-between items-center text-sm text-gray-500 mb-4">
//                     <span>{content.pages} pages</span>
//                     <span>{content.format}</span>
//                     <span>Updated: {formatDate(content.updatedAt)}</span>
//                   </div>

//                   <Link
//                     to={`/content/${content._id}`}
//                     className="block w-full text-center py-2 px-4 border border-[#2C5282] rounded-md text-[#2C5282] font-medium hover:bg-[#2C5282] hover:text-white transition-colors duration-300"
//                   >
//                     View Details
//                   </Link>
//                 </div>
//               </motion.div>
//             ))}
//           </div>

//           {/* Show message if no content in selected category */}
//           {filteredContents.length === 0 && (
//             <div className="text-center py-16">
//               <h3 className="text-xl text-gray-600 mb-2">
//                 No content available in this category yet
//               </h3>
//               <p className="text-gray-500">
//                 Please check back later or explore other categories
//               </p>
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Benefits Section */}
//       <section className="py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-16">
//             <motion.h2
//               className="text-3xl font-extrabold text-[#2C5282] sm:text-4xl"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               Why Choose Our Smart Content?
//             </motion.h2>
//             <motion.p
//               className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Designed by experts to make your exam preparation more efficient
//               and effective
//             </motion.p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {benefits.map((benefit, index) => (
//               <motion.div
//                 key={benefit.id}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 className="flex items-start bg-gray-50 p-6 rounded-lg"
//               >
//                 <div className="flex-shrink-0">
//                   <div className="flex items-center justify-center h-12 w-12 rounded-md bg-[#2C5282] text-white">
//                     {benefit.icon}
//                   </div>
//                 </div>
//                 <div className="ml-4">
//                   <h3 className="text-lg font-medium text-gray-900">
//                     {benefit.title}
//                   </h3>
//                   <p className="mt-2 text-gray-600">{benefit.description}</p>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Testimonials Section */}
//       <section className="py-16 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-16">
//             <motion.h2
//               className="text-3xl font-extrabold text-[#2C5282] sm:text-4xl"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               What Our Students Say
//             </motion.h2>
//             <motion.p
//               className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Success stories from students who used our smart content
//             </motion.p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {testimonials.map((testimonial, index) => (
//               <motion.div
//                 key={testimonial.id}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 className="bg-white p-6 rounded-lg border border-gray-200 shadow-md"
//               >
//                 <p className="italic text-gray-600 mb-6">
//                   "{testimonial.content}"
//                 </p>
//                 <div className="flex items-center">
//                   <div className="mr-4 h-12 w-12 rounded-full overflow-hidden border-2 border-[#2C5282]">
//                     <img
//                       src={testimonial.image}
//                       alt={testimonial.author}
//                       className="h-full w-full object-cover"
//                     />
//                   </div>
//                   <div>
//                     <h3 className="font-bold text-lg text-[#2C5282]">
//                       {testimonial.author}
//                     </h3>
//                     <p className="text-gray-600 font-medium">
//                       {testimonial.rank}
//                     </p>
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Subscription Plans Section */}
//       <section className="py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-16">
//             <motion.h2
//               className="text-3xl font-extrabold text-[#2C5282] sm:text-4xl"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               Choose Your Access Plan
//             </motion.h2>
//             <motion.p
//               className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Flexible subscription options to meet your study needs
//             </motion.p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {/* Basic Plan */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//               className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200"
//             >
//               <div className="p-8 text-center">
//                 <h3 className="text-2xl font-bold text-[#2C5282] mb-2">
//                   Basic
//                 </h3>
//                 <p className="text-gray-600 mb-6">
//                   Essential content for exam preparation
//                 </p>
//                 <div className="flex justify-center items-end mb-6">
//                   <span className="text-5xl font-extrabold text-[#2C5282]">
//                     ₹1,999
//                   </span>
//                   <span className="text-gray-600 ml-2">/year</span>
//                 </div>
//                 <ul className="text-left space-y-4 mb-8">
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Access to Academic Notes
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Basic Model Question Papers
//                     </span>
//                   </li>
//                   <li className="flex items-start text-gray-400">
//                     <svg
//                       className="h-5 w-5 text-gray-400 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="current"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M6 18L18 6M6 6l12 12"
//                       />
//                     </svg>
//                     <span className="ml-3">SSLC Board Old Question Papers</span>
//                   </li>
//                   <li className="flex items-start text-gray-400">
//                     <svg
//                       className="h-5 w-5 text-gray-400 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M6 18L18 6M6 6l12 12"
//                       />
//                     </svg>
//                     <span className="ml-3">Textbook Solutions</span>
//                   </li>
//                 </ul>
//                 <Link
//                   to="/register?plan=basic"
//                   className="block w-full bg-gray-100 hover:bg-gray-200 text-gray-900 font-medium rounded-md py-3 px-4 transition-colors duration-300"
//                 >
//                   Get Started
//                 </Link>
//               </div>
//             </motion.div>

//             {/* Standard Plan */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//               className="bg-white rounded-lg shadow-lg overflow-hidden border-2 border-[#2C5282] relative transform scale-105 z-10"
//             >
//               <div className="absolute top-0 inset-x-0 flex justify-center">
//                 <span className="inline-block px-4 py-1 rounded-b-lg text-xs font-semibold tracking-wide uppercase bg-[#2C5282] text-white">
//                   Most Popular
//                 </span>
//               </div>
//               <div className="p-8 text-center pt-12">
//                 <h3 className="text-2xl font-bold text-[#2C5282] mb-2">
//                   Standard
//                 </h3>
//                 <p className="text-gray-600 mb-6">
//                   Complete content for serious students
//                 </p>
//                 <div className="flex justify-center items-end mb-6">
//                   <span className="text-5xl font-extrabold text-[#2C5282]">
//                     ₹2,999
//                   </span>
//                   <span className="text-gray-600 ml-2">/year</span>
//                 </div>
//                 <ul className="text-left space-y-4 mb-8">
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Access to <strong>all</strong> Academic Notes
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       All Model Question Papers
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       SSLC Board Old Question Papers
//                     </span>
//                   </li>
//                   <li className="flex items-start text-gray-400">
//                     <svg
//                       className="h-5 w-5 text-gray-400 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M6 18L18 6M6 6l12 12"
//                       />
//                     </svg>
//                     <span className="ml-3">Textbook Solutions</span>
//                   </li>
//                 </ul>
//                 <Link
//                   to="/register?plan=standard"
//                   className="block w-full bg-[#2C5282] hover:bg-[#1A365D] text-white font-medium rounded-md py-3 px-4 transition-colors duration-300"
//                 >
//                   Get Started
//                 </Link>
//               </div>
//             </motion.div>

//             {/* Premium Plan */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//               className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200"
//             >
//               <div className="p-8 text-center">
//                 <h3 className="text-2xl font-bold text-[#2C5282] mb-2">
//                   Premium
//                 </h3>
//                 <p className="text-gray-600 mb-6">
//                   Complete package for top performance
//                 </p>
//                 <div className="flex justify-center items-end mb-6">
//                   <span className="text-5xl font-extrabold text-[#2C5282]">
//                     ₹4,999
//                   </span>
//                   <span className="text-gray-600 ml-2">/year</span>
//                 </div>
//                 <ul className="text-left space-y-4 mb-8">
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       <strong>Everything</strong> in Standard plan
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Complete Textbook Solutions
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Special Entrance Exam Content (Navodaya & Morarji)
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Monthly Doubt Clearing Sessions
//                     </span>
//                   </li>
//                 </ul>
//                 <Link
//                   to="/register?plan=premium"
//                   className="block w-full bg-[#1A365D] hover:bg-[#2C5282] text-white font-medium rounded-md py-3 px-4 transition-colors duration-300"
//                 >
//                   Get Started
//                 </Link>
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* FAQ Section */}
//       <section className="py-16 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-16">
//             <motion.h2
//               className="text-3xl font-extrabold text-[#2C5282] sm:text-4xl"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               Frequently Asked Questions
//             </motion.h2>
//             <motion.p
//               className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Answers to common questions about our smart content
//             </motion.p>
//           </div>

//           <div className="max-w-3xl mx-auto divide-y divide-gray-200">
//             <div className="py-6">
//               <h3 className="text-lg font-medium text-[#2C5282]">
//                 How is your content different from standard textbooks?
//               </h3>
//               <p className="mt-2 text-gray-600">
//                 Our content is specifically designed for exam preparation,
//                 focusing on important concepts and question patterns. We provide
//                 academic notes, previous years' question papers, and model test
//                 papers that help you prepare efficiently.
//               </p>
//             </div>
//             <div className="py-6">
//               <h3 className="text-lg font-medium text-[#2C5282]">
//                 Can I download the content for offline reading?
//               </h3>
//               <p className="mt-2 text-gray-600">
//                 Yes, all our content is available in downloadable PDF format.
//                 Once you subscribe, you can download the materials and access
//                 them offline on any device.
//               </p>
//             </div>
//             <div className="py-6">
//               <h3 className="text-lg font-medium text-[#2C5282]">
//                 How often is the content updated?
//               </h3>
//               <p className="mt-2 text-gray-600">
//                 We update our content regularly to incorporate the latest
//                 examination patterns and syllabus changes. Question papers are
//                 updated annually after each board examination cycle.
//               </p>
//             </div>
//             <div className="py-6">
//               <h3 className="text-lg font-medium text-[#2C5282]">
//                 Do you provide content for entrance exams like Navodaya and
//                 Morarji?
//               </h3>
//               <p className="mt-2 text-gray-600">
//                 Yes, our Premium plan includes specialized content for entrance
//                 exams like Navodaya and Morarji, including notes and question
//                 papers specifically designed for these competitive exams.
//               </p>
//             </div>
//             <div className="py-6">
//               <h3 className="text-lg font-medium text-[#2C5282]">
//                 Can I upgrade my plan later?
//               </h3>
//               <p className="mt-2 text-gray-600">
//                 Absolutely. You can upgrade your subscription plan at any time,
//                 paying only the difference between your current plan and the new
//                 one. The upgraded access will be available immediately.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Call to Action */}
//       <section className="py-16 bg-gradient-to-br from-[#2C5282] to-[#1A365D] text-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="max-w-3xl mx-auto text-center">
//             <motion.h2
//               className="text-3xl font-extrabold mb-6"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               Ready to Transform Your Exam Preparation?
//             </motion.h2>
//             <motion.p
//               className="text-lg text-blue-100 mb-8"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Join thousands of successful students who have optimized their
//               preparation with our smart content.
//             </motion.p>
//             <motion.div
//               className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//             >
//               <Link
//                 to="/register"
//                 className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-[#2C5282] bg-white hover:bg-gray-100 transition-colors duration-300 shadow-md"
//               >
//                 Get Started Now
//               </Link>
//               <Link
//                 to="/contact"
//                 className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
//               >
//                 Contact Us
//               </Link>
//             </motion.div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default SmartContentsPage;
// pages/SmartContentsPage.jsx
import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../components/common/Spinner";
import { CONSTANTS } from "../constants/Constants";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebaseConfig";
import SecurePdfViewer from "../components/SecurePDFViewer";
import { useEnrollment } from "../context/EnrollmentContext";
import LockedSection from "../components/LockedSection";

// Secure PDF Viewer Component
// const SecurePDFViewer = ({ pdfUrl, onClose, contentTitle }) => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Security measures
//   useEffect(() => {
//     // Disable right-click context menu
//     const disableRightClick = (e) => {
//       e.preventDefault();
//       return false;
//     };

//     // Disable text selection
//     const disableSelection = () => {
//       document.body.style.userSelect = 'none';
//       document.body.style.webkitUserSelect = 'none';
//       document.body.style.msUserSelect = 'none';
//     };

//     // Disable developer tools shortcuts
//     const disableDevTools = (e) => {
//       // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
//       if (
//         e.keyCode === 123 || // F12
//         (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I
//         (e.ctrlKey && e.shiftKey && e.keyCode === 74) || // Ctrl+Shift+J
//         (e.ctrlKey && e.keyCode === 85) || // Ctrl+U
//         (e.ctrlKey && e.shiftKey && e.keyCode === 67) // Ctrl+Shift+C
//       ) {
//         e.preventDefault();
//         toast.error("Developer tools are disabled for security reasons");
//         return false;
//       }
//     };

//     // Disable copy, cut, paste
//     const disableCopyPaste = (e) => {
//       if (e.ctrlKey && (e.keyCode === 67 || e.keyCode === 88 || e.keyCode === 86)) {
//         e.preventDefault();
//         toast.error("Copy/Paste is disabled for content protection");
//         return false;
//       }
//     };

//     // Apply security measures
//     document.addEventListener('contextmenu', disableRightClick);
//     document.addEventListener('keydown', disableDevTools);
//     document.addEventListener('keydown', disableCopyPaste);
//     disableSelection();

//     // Cleanup on unmount
//     return () => {
//       document.removeEventListener('contextmenu', disableRightClick);
//       document.removeEventListener('keydown', disableDevTools);
//       document.removeEventListener('keydown', disableCopyPaste);
//       document.body.style.userSelect = '';
//       document.body.style.webkitUserSelect = '';
//       document.body.style.msUserSelect = '';
//     };
//   }, []);

//   // Handle PDF load
//   const handlePDFLoad = () => {
//     setIsLoading(false);
//   };

//   // Handle PDF error
//   const handlePDFError = () => {
//     setIsLoading(false);
//     setError("Failed to load PDF. Please try again later.");
//   };

//   return (
//     <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex flex-col">
//       {/* Header */}
//       <div className="bg-[#2C5282] text-white p-4 flex justify-between items-center">
//         <div>
//           <h3 className="text-lg font-semibold">{contentTitle}</h3>
//           <p className="text-sm text-blue-200">Secure Content Viewer</p>
//         </div>
//         <button
//           onClick={onClose}
//           className="text-white hover:text-gray-300 transition-colors"
//           aria-label="Close viewer"
//         >
//           <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//           </svg>
//         </button>
//       </div>

//       {/* Content Area */}
//       <div className="flex-1 relative bg-gray-100">
//         {isLoading && (
//           <div className="absolute inset-0 flex items-center justify-center">
//             <div className="bg-white p-6 rounded-lg shadow-lg">
//               <Loader />
//               <p className="mt-4 text-gray-600">Loading secure content...</p>
//             </div>
//           </div>
//         )}

//         {error && (
//           <div className="absolute inset-0 flex items-center justify-center">
//             <div className="bg-white p-6 rounded-lg shadow-lg text-center">
//               <div className="text-red-500 mb-4">
//                 <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
//                 </svg>
//               </div>
//               <p className="text-gray-700">{error}</p>
//               <button
//                 onClick={onClose}
//                 className="mt-4 px-4 py-2 bg-[#2C5282] text-white rounded hover:bg-[#1A365D] transition-colors"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         )}

//         {/* PDF Iframe with security measures */}
//         <iframe
//           src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0&scrollbar=0`}
//           className="w-full h-full border-0"
//           onLoad={handlePDFLoad}
//           onError={handlePDFError}
//           sandbox="allow-same-origin allow-scripts"
//           style={{
//             pointerEvents: 'auto',
//             userSelect: 'none',
//             WebkitUserSelect: 'none',
//             msUserSelect: 'none'
//           }}
//           title={`${contentTitle} - Secure PDF Viewer`}
//         />

//         {/* Overlay to prevent direct interaction */}
//         <div
//           className="absolute inset-0 pointer-events-none"
//           style={{
//             background: 'transparent',
//             userSelect: 'none',
//             WebkitUserSelect: 'none',
//             msUserSelect: 'none'
//           }}
//         />
//       </div>

//       {/* Footer */}
//       <div className="bg-[#2C5282] text-white p-3 text-center">
//         <p className="text-sm text-blue-200">
//           🔒 Protected Content - Downloading and copying are disabled for security
//         </p>
//       </div>
//     </div>
//   );
// };

const SmartContentsPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("all");
  const [activeSubTab, setActiveSubTab] = useState(null);
  const [contentCategories, setContentCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [smartContents, setSmartContents] = useState([]);
  const [filteredContents, setFilteredContents] = useState([]);
  const [benefits, setBenefits] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  // PDF Viewer state
  const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState("");
  const [currentContentTitle, setCurrentContentTitle] = useState("");
  const { activeEnrollments, loading: enrollmentLoading } = useEnrollment();

  // Fetch all required data
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  // Filter contents based on active tab and subtab
  useEffect(() => {
    if (activeTab === "all") {
      setFilteredContents(smartContents);
      setActiveSubTab(null);
    } else {
      const contentsForCategory = smartContents.filter(
        (content) => content.category === activeTab
      );

      if (activeSubTab) {
        const contentsForSubCategory = contentsForCategory.filter(
          (content) => content.subCategory === activeSubTab
        );
        setFilteredContents(contentsForSubCategory);
      } else {
        setFilteredContents(contentsForCategory);
      }
    }
  }, [activeTab, activeSubTab, smartContents]);

  const fetchData = async () => {
    try {
      setLoading(true);

      // Try to fetch from Firestore first
      let categoriesData = [];
      let contentsData = [];

      try {
        // Fetch categories from Firestore
        const categoriesSnapshot = await getDocs(
          collection(db, "contentCategories")
        );
        categoriesData = categoriesSnapshot.docs.map((doc) => ({
          _id: doc.id,
          ...doc.data(),
          identifier: doc.data().identifier || doc.id,
        }));

        // Fetch content from Firestore
        const contentsSnapshot = await getDocs(collection(db, "smartContents"));
        contentsData = contentsSnapshot.docs.map((doc) => ({
          _id: doc.id,
          ...doc.data(),
          updatedAt: doc.data().updatedAt?.toDate?.() || new Date(),
        }));
      } catch (firestoreError) {
        console.error("Firestore error:", firestoreError);

        // Fallback to API if Firestore fails
        try {
          // Fetch categories from API
          const categoriesRes = await axios.get(
            `${CONSTANTS.APIURL}/api/content-categories?active=true`
          );
          categoriesData = categoriesRes.data.data;

          // Fetch smart contents from API
          const contentsRes = await axios.get(
            `${CONSTANTS.APIURL}/api/smart-contents`
          );
          contentsData = contentsRes.data.data;
        } catch (apiError) {
          console.error("API error:", apiError);
          toast.error("Failed to load content data");

          // If both fail, use hardcoded data
          categoriesData = getDefaultCategories();
          contentsData = getDefaultContents();
        }
      }

      // Add "All Content" category at the beginning
      const allCategories = [
        { _id: "all", name: "All Content", identifier: "all" },
        ...categoriesData,
      ];

      setContentCategories(allCategories);
      setSmartContents(contentsData);

      // Set sub-categories based on the diagram
      const defaultSubcategories = {
        "10th_eng": [
          { id: "academic_notes", name: "Academic Notes" },
          { id: "sslc_board", name: "SSLC Board Old Q.P." },
          { id: "model_qp", name: "Model Q.P." },
          { id: "textbook", name: "Text Book" },
        ],
        "10th_kannada": [
          { id: "academic_notes", name: "Academic Notes" },
          { id: "sslc_board", name: "SSLC Board Old Q.P." },
          { id: "model_qp", name: "Model Q.P." },
          { id: "textbook", name: "Text Book" },
        ],
        navodaya: [
          { id: "notes", name: "Notes" },
          { id: "model_qp", name: "Q.P." },
        ],
        morarji: [
          { id: "notes", name: "Notes" },
          { id: "model_qp", name: "Q.P." },
        ],
        ncert: [
          { id: "notes", name: "Notes" },
          { id: "model_qp", name: "Q.P." },
        ],
      };

      setSubCategories(defaultSubcategories);

      // Fetch static data (benefits and testimonials)
      fetchStaticData();

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load content data");
      setLoading(false);
    }
  };

  // Default categories if API/Firestore fails
  const getDefaultCategories = () => {
    return [
      { _id: "10th_eng", name: "10th English", identifier: "10th_eng" },
      { _id: "10th_kannada", name: "10th Kannada", identifier: "10th_kannada" },
      { _id: "navodaya", name: "Navodaya", identifier: "navodaya" },
      { _id: "morarji", name: "Morarji", identifier: "morarji" },
      { _id: "ncert", name: "NCERT", identifier: "ncert" },
    ];
  };

  // Default contents if API/Firestore fails
  const getDefaultContents = () => {
    const defaultImages = [
      "https://images.unsplash.com/photo-1503676260728-1c00da094a0b",
      "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8",
      "https://images.unsplash.com/photo-1522661067900-ab829854a57f",
      "https://images.unsplash.com/photo-1434030216411-0b793f4b4173",
    ];

    // Sample PDF URLs for demonstration
    const samplePDFs = [
      "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
      "https://www.adobe.com/support/products/enterprise/knowledgecenter/media/c4611_sample_explain.pdf",
      "https://file-examples.com/storage/fe68c1e7f69230b2df0b6fa/2017/10/file_example_PDF_500_kB.pdf",
      "https://www.clickdimensions.com/links/TestPDFfile.pdf",
    ];

    // Generate sample contents for each category and subcategory
    const contents = [];
    const categories = getDefaultCategories();

    categories.forEach((category) => {
      const subcats = {
        "10th_eng": ["academic_notes", "sslc_board", "model_qp", "textbook"],
        "10th_kannada": [
          "academic_notes",
          "sslc_board",
          "model_qp",
          "textbook",
        ],
        navodaya: ["notes", "model_qp"],
        morarji: ["notes", "model_qp"],
        ncert: ["notes", "model_qp"],
      }[category.identifier] || ["notes"];

      subcats.forEach((subcat) => {
        // Add 3 sample items for each subcategory
        for (let i = 1; i <= 3; i++) {
          contents.push({
            _id: `${category.identifier}_${subcat}_${i}`,
            title: `${category.name} - ${subcat.replace("_", " ")} ${i}`,
            description: `Sample ${category.name} ${subcat.replace(
              "_",
              " "
            )} content for educational purposes.`,
            category: category.identifier,
            subCategory: subcat,
            imageUrl:
              defaultImages[Math.floor(Math.random() * defaultImages.length)],
            pages: Math.floor(Math.random() * 50) + 10,
            format: Math.random() > 0.5 ? "PDF" : "DOC",
            pdfUrl: samplePDFs[Math.floor(Math.random() * samplePDFs.length)], // Add PDF URL
            updatedAt: new Date(
              Date.now() - Math.floor(Math.random() * 90) * 24 * 60 * 60 * 1000
            ),
            popular: Math.random() > 0.8,
          });
        }
      });
    });

    return contents;
  };

  // Fetch static data (benefits and testimonials)
  const fetchStaticData = () => {
    const benefitsData = [
      {
        id: 1,
        title: "Exam-Focused Content",
        description:
          "Content prepared by experts focusing only on exam-relevant information.",
        icon: (
          <svg
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
            />
          </svg>
        ),
      },
      {
        id: 2,
        title: "Regular Updates",
        description:
          "Content regularly updated to include the latest examination patterns and syllabus changes.",
        icon: (
          <svg
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        ),
      },
      {
        id: 3,
        title: "Simplified Complex Topics",
        description:
          "Difficult concepts simplified using easy language, diagrams, and examples.",
        icon: (
          <svg
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 10V3L4 14h7v7l9-11h-7z"
            />
          </svg>
        ),
      },
      {
        id: 4,
        title: "Multiple Formats",
        description:
          "Content available in various formats including notes, model question papers, previous year questions, and textbook references.",
        icon: (
          <svg
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
            />
          </svg>
        ),
      },
    ];

    const testimonialsData = [
      {
        id: 1,
        content:
          "The smart content provided by SKYSEP was instrumental in my exam preparation. The concise notes and question papers helped me revise effectively.",
        author: "Priya Verma",
        rank: "96% in 10th Standard, 2023",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDjtNi1m_f5OuxG9GcNMqa9i4F2sq_dVREdA&s",
      },
      {
        id: 2,
        content:
          "What sets SKYSEP's study material apart is how they simplify complex topics. The question papers and notes especially helped me prepare thoroughly.",
        author: "Rahul Sharma",
        rank: "Selected for Navodaya, 2023",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDjtNi1m_f5OuxG9GcNMqa9i4F2sq_dVREdA&s",
      },
      {
        id: 3,
        content:
          "The model question papers and SSLC board old question papers were extremely helpful. They gave me a good idea of what to expect in the exams.",
        author: "Amit Patel",
        rank: "98% in Science, 2023",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyBOAHtlqzaow5_rlz81tF3SwDxw4m5bYPzQ&s",
      },
    ];

    setBenefits(benefitsData);
    setTestimonials(testimonialsData);
  };

  // Function to format date
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  // Handle PDF view
  const handleViewPDF = useCallback((content) => {
    if (content.pdfUrl) {
      setCurrentPdfUrl(content.pdfUrl);
      setCurrentContentTitle(content.title);
      setPdfViewerOpen(true);
    } else {
      toast.error("PDF not available for this content");
    }
  }, []);

  // Close PDF viewer
  const closePDFViewer = useCallback(() => {
    setPdfViewerOpen(false);
    setCurrentPdfUrl("");
    setCurrentContentTitle("");
  }, []);

  if (loading) {
    return <Loader />;
  }
  if (activeEnrollments?.length === 0) {
    return <LockedSection />;
  }
  return (
    <div className="pt-20">
      {/* PDF Viewer Modal */}
      {pdfViewerOpen && (
        <SecurePdfViewer
          pdfUrl={currentPdfUrl}
          // compilation={selectedCompilation}
          onClose={closePDFViewer}
        />
      )}

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#2C5282] to-[#1A365D] text-white">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[#2C5282] opacity-70"></div>
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&h=750&q=80')] opacity-10"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="max-w-3xl">
            <motion.h1
              className="text-4xl md:text-5xl font-extrabold tracking-tight mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Smart Study Content
            </motion.h1>
            <motion.p
              className="text-lg md:text-xl mb-8 text-blue-100"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Access comprehensive study materials designed by experts to help
              you excel in your exams. Choose from a wide range of academic
              notes, question papers, and textbook resources.
            </motion.p>
            <motion.div
              className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <a
                href="#smart-content-grid"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-[#2C5282] bg-white hover:bg-gray-100 transition-colors duration-300 shadow-md"
              >
                Access Smart Content
              </a>
              <button
                onClick={() => {
                  handleViewPDF({
                    pdfUrl:
                      "https://firebasestorage.googleapis.com/v0/b/skyholistics-1366c.appspot.com/o/content-pdfs%2Fpdf_1749562006394_THE%20ADVENT%20OF%20EUROPEANS%20TO%20INDIA.pdf?alt=media&token=78f1c9b6-34ef-424f-8de2-ee942ef9103c",
                    title: "Sample Content PDF",
                  });
                }}
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
              >
                View Sample Content
              </button>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Main Category Filter Tabs */}
      <section className="bg-white py-8 border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center">
            {contentCategories.map((category) => (
              <button
                key={category._id}
                onClick={() => {
                  setActiveTab(category.identifier);
                  setActiveSubTab(null);
                }}
                className={`px-5 py-2 m-1 rounded-full text-sm font-medium transition-colors ${
                  activeTab === category.identifier
                    ? "bg-[#2C5282] text-white"
                    : "bg-blue-50 text-[#2C5282] hover:bg-blue-100"
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Sub-Category Filter Tabs - Only show if a main category is selected */}
      {activeTab !== "all" && subCategories[activeTab] && (
        <section className="bg-gray-50 py-4">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap justify-center">
              {subCategories[activeTab].map((subCategory) => (
                <button
                  key={subCategory.id}
                  onClick={() => setActiveSubTab(subCategory.id)}
                  className={`px-4 py-1 m-1 rounded-md text-sm transition-colors ${
                    activeSubTab === subCategory.id
                      ? "bg-blue-200 text-blue-800 font-medium"
                      : "bg-white text-gray-600 hover:bg-blue-50"
                  }`}
                >
                  {subCategory.name}
                </button>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Content Grid */}
      <section className="py-16 bg-gray-50" id="smart-content-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredContents.map((content, index) => (
              <motion.div
                key={content._id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow duration-300"
              >
                <div className="relative h-48">
                  <img
                    src={content.imageUrl}
                    alt={content.title}
                    className="w-full h-full object-cover"
                  />
                  {content.popular && (
                    <span className="absolute top-0 right-0 bg-[#2C5282] text-white px-3 py-1 text-xs font-medium">
                      Popular
                    </span>
                  )}
                  {/* PDF indicator */}
                  <div className="absolute bottom-2 left-2 bg-red-600 text-white px-2 py-1 text-xs rounded">
                    📄 PDF
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#2C5282] mb-2">
                    {content.title}
                  </h3>
                  <p className="text-gray-600 mb-4 text-sm">
                    {content.description}
                  </p>

                  <div className="flex justify-between items-center text-sm text-gray-500 mb-4">
                    <span>{content.pages} pages</span>
                    <span>{content.format}</span>
                    <span>Updated: {formatDate(content.updatedAt)}</span>
                  </div>

                  <div className="flex space-x-2">
                    <button
                      onClick={() => handleViewPDF(content)}
                      className="flex-1 py-2 px-4 bg-[#2C5282] text-white rounded-md font-medium hover:bg-[#1A365D] transition-colors duration-300 flex items-center justify-center"
                    >
                      <svg
                        className="w-4 h-4 mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                      View PDF
                    </button>
                    {/* <Link
                      to={`/content/${content._id}`}
                      className="flex-1 text-center py-2 px-4 border border-[#2C5282] rounded-md text-[#2C5282] font-medium hover:bg-[#2C5282] hover:text-white transition-colors duration-300"
                    >
                      Details
                    </Link> */}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Show message if no content in selected category */}
          {filteredContents.length === 0 && (
            <div className="text-center py-16">
              <h3 className="text-xl text-gray-600 mb-2">
                No content available in this category yet
              </h3>
              <p className="text-gray-500">
                Please check back later or explore other categories
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <motion.h2
              className="text-3xl font-extrabold text-[#2C5282] sm:text-4xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Why Choose Our Smart Content?
            </motion.h2>
            <motion.p
              className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Designed by experts to make your exam preparation more efficient
              and effective
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {benefits.map((benefit, index) => (
              <motion.div
                key={benefit.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex items-start bg-gray-50 p-6 rounded-lg"
              >
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-[#2C5282] text-white">
                    {benefit.icon}
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    {benefit.title}
                  </h3>
                  <p className="mt-2 text-gray-600">{benefit.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <motion.h2
              className="text-3xl font-extrabold text-[#2C5282] sm:text-4xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              What Our Students Say
            </motion.h2>
            <motion.p
              className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Success stories from students who used our smart content
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg border border-gray-200 shadow-md"
              >
                <p className="italic text-gray-600 mb-6">
                  "{testimonial.content}"
                </p>
                <div className="flex items-center">
                  <div className="mr-4 h-12 w-12 rounded-full overflow-hidden border-2 border-[#2C5282]">
                    <img
                      src={testimonial.image}
                      alt={testimonial.author}
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg text-[#2C5282]">
                      {testimonial.author}
                    </h3>
                    <p className="text-gray-600 font-medium">
                      {testimonial.rank}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Subscription Plans Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <motion.h2
              className="text-3xl font-extrabold text-[#2C5282] sm:text-4xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Choose Your Access Plan
            </motion.h2>
            <motion.p
              className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Flexible subscription options to meet your study needs
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Basic Plan */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200"
            >
              <div className="p-8 text-center">
                <h3 className="text-2xl font-bold text-[#2C5282] mb-2">
                  Basic
                </h3>
                <p className="text-gray-600 mb-6">
                  Essential content for exam preparation
                </p>
                <div className="flex justify-center items-end mb-6">
                  <span className="text-5xl font-extrabold text-[#2C5282]">
                    ₹1,999
                  </span>
                  <span className="text-gray-600 ml-2">/year</span>
                </div>
                <ul className="text-left space-y-4 mb-8">
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Access to Academic Notes
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Basic Model Question Papers
                    </span>
                  </li>
                  <li className="flex items-start text-gray-400">
                    <svg
                      className="h-5 w-5 text-gray-400 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    <span className="ml-3">SSLC Board Old Question Papers</span>
                  </li>
                  <li className="flex items-start text-gray-400">
                    <svg
                      className="h-5 w-5 text-gray-400 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    <span className="ml-3">Textbook Solutions</span>
                  </li>
                </ul>
                <Link
                  to="/register?plan=basic"
                  className="block w-full bg-gray-100 hover:bg-gray-200 text-gray-900 font-medium rounded-md py-3 px-4 transition-colors duration-300"
                >
                  Get Started
                </Link>
              </div>
            </motion.div>

            {/* Standard Plan */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white rounded-lg shadow-lg overflow-hidden border-2 border-[#2C5282] relative transform scale-105 z-10"
            >
              <div className="absolute top-0 inset-x-0 flex justify-center">
                <span className="inline-block px-4 py-1 rounded-b-lg text-xs font-semibold tracking-wide uppercase bg-[#2C5282] text-white">
                  Most Popular
                </span>
              </div>
              <div className="p-8 text-center pt-12">
                <h3 className="text-2xl font-bold text-[#2C5282] mb-2">
                  Standard
                </h3>
                <p className="text-gray-600 mb-6">
                  Complete content for serious students
                </p>
                <div className="flex justify-center items-end mb-6">
                  <span className="text-5xl font-extrabold text-[#2C5282]">
                    ₹2,999
                  </span>
                  <span className="text-gray-600 ml-2">/year</span>
                </div>
                <ul className="text-left space-y-4 mb-8">
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Access to <strong>all</strong> Academic Notes
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      All Model Question Papers
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      SSLC Board Old Question Papers
                    </span>
                  </li>
                  <li className="flex items-start text-gray-400">
                    <svg
                      className="h-5 w-5 text-gray-400 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    <span className="ml-3">Textbook Solutions</span>
                  </li>
                </ul>
                <Link
                  to="/register?plan=standard"
                  className="block w-full bg-[#2C5282] hover:bg-[#1A365D] text-white font-medium rounded-md py-3 px-4 transition-colors duration-300"
                >
                  Get Started
                </Link>
              </div>
            </motion.div>

            {/* Premium Plan */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200"
            >
              <div className="p-8 text-center">
                <h3 className="text-2xl font-bold text-[#2C5282] mb-2">
                  Premium
                </h3>
                <p className="text-gray-600 mb-6">
                  Complete package for top performance
                </p>
                <div className="flex justify-center items-end mb-6">
                  <span className="text-5xl font-extrabold text-[#2C5282]">
                    ₹4,999
                  </span>
                  <span className="text-gray-600 ml-2">/year</span>
                </div>
                <ul className="text-left space-y-4 mb-8">
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      <strong>Everything</strong> in Standard plan
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Complete Textbook Solutions
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Special Entrance Exam Content (Navodaya & Morarji)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Monthly Doubt Clearing Sessions
                    </span>
                  </li>
                </ul>
                <Link
                  to="/register?plan=premium"
                  className="block w-full bg-[#1A365D] hover:bg-[#2C5282] text-white font-medium rounded-md py-3 px-4 transition-colors duration-300"
                >
                  Get Started
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <motion.h2
              className="text-3xl font-extrabold text-[#2C5282] sm:text-4xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Frequently Asked Questions
            </motion.h2>
            <motion.p
              className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Answers to common questions about our smart content
            </motion.p>
          </div>

          <div className="max-w-3xl mx-auto divide-y divide-gray-200">
            <div className="py-6">
              <h3 className="text-lg font-medium text-[#2C5282]">
                How is your content different from standard textbooks?
              </h3>
              <p className="mt-2 text-gray-600">
                Our content is specifically designed for exam preparation,
                focusing on important concepts and question patterns. We provide
                academic notes, previous years' question papers, and model test
                papers that help you prepare efficiently.
              </p>
            </div>
            <div className="py-6">
              <h3 className="text-lg font-medium text-[#2C5282]">
                Can I download the content for offline reading?
              </h3>
              <p className="mt-2 text-gray-600">
                Our content is available for secure viewing through our
                protected PDF viewer. This ensures content security while
                providing you with a seamless reading experience.
              </p>
            </div>
            <div className="py-6">
              <h3 className="text-lg font-medium text-[#2C5282]">
                How often is the content updated?
              </h3>
              <p className="mt-2 text-gray-600">
                We update our content regularly to incorporate the latest
                examination patterns and syllabus changes. Question papers are
                updated annually after each board examination cycle.
              </p>
            </div>
            <div className="py-6">
              <h3 className="text-lg font-medium text-[#2C5282]">
                Do you provide content for entrance exams like Navodaya and
                Morarji?
              </h3>
              <p className="mt-2 text-gray-600">
                Yes, our Premium plan includes specialized content for entrance
                exams like Navodaya and Morarji, including notes and question
                papers specifically designed for these competitive exams.
              </p>
            </div>
            <div className="py-6">
              <h3 className="text-lg font-medium text-[#2C5282]">
                Can I upgrade my plan later?
              </h3>
              <p className="mt-2 text-gray-600">
                Absolutely. You can upgrade your subscription plan at any time,
                paying only the difference between your current plan and the new
                one. The upgraded access will be available immediately.
              </p>
            </div>
            <div className="py-6">
              <h3 className="text-lg font-medium text-[#2C5282]">
                Is the PDF viewer secure?
              </h3>
              <p className="mt-2 text-gray-600">
                Yes, our PDF viewer includes multiple security features
                including disabled right-click, copy protection, developer tools
                blocking, and prevents unauthorized downloads to protect our
                content.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-br from-[#2C5282] to-[#1A365D] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <motion.h2
              className="text-3xl font-extrabold mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Ready to Transform Your Exam Preparation?
            </motion.h2>
            <motion.p
              className="text-lg text-blue-100 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Join thousands of successful students who have optimized their
              preparation with our smart content.
            </motion.p>
            <motion.div
              className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Link
                to="/register"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-[#2C5282] bg-white hover:bg-gray-100 transition-colors duration-300 shadow-md"
              >
                Get Started Now
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
              >
                Contact Us
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SmartContentsPage;
